import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import { login } from '../services/api';
import { useAuth } from '../context/AuthContext';
import MessageModal from '../components/MessageModal';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setAuthData } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      console.log('Attempting login for user:', username);
      const result = await login(username, password);
      console.log('Login response:', result);
      
      // Check if response indicates an error
      if (result && result.status === 'Invalid password') {
        setError('User name or password are incorrect');
        setLoading(false);
        return;
      }
      
      // Check if user id is between 1-10
      if (!result || !result.id || result.id < 1 || result.id > 10) {
        const errorMsg = result?.id ? 'You are not authorized to access' : 'Invalid login response';
        console.error('Authorization failed:', result);
        setError(errorMsg);
        setLoading(false);
        return;
      }

      // Store auth data (normalize name fields; fall back to typed username)
      const authDataToStore = {
        userId: result.id,
        userName: result.userName || result.UserName || result.username || username,
        fullName: result.fullName || result.FullName || result.name || result.userName || result.UserName || username,
        siteIds: result.sites?.map(site => site.id) || []
      };
      console.log('Storing auth data:', authDataToStore);
      setAuthData(authDataToStore);

      // Small delay to ensure state is updated before navigation
      setTimeout(() => {
        navigate('/');
      }, 100);
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'User name or password are incorrect');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img 
              src="/mypark-logo.png" 
              alt="MYPARK SMART PARKING" 
              className="login-logo-img"
            />
          </div>
          <h1 className="login-title">Monitoring Dashboard</h1>
          <p className="login-subtitle">Please sign in to continue</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username" className="form-label">Username</label>
            <input
              type="text"
              id="username"
              className="form-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">Password</label>
            <input
              type="password"
              id="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>

      {error && (
        <MessageModal
          type="error"
          message={error}
          show={!!error}
          onClose={() => setError(null)}
        />
      )}
    </div>
  );
};

export default Login;

